import { Box, useTheme } from "@mui/material";
import { useHomeRoute } from "hooks/useHomeRoute";
import { useThemeMode } from "hooks/useThemeMode";

import { homeLinesBackgroundSx, homeLinesVeilColor } from "./homeLinesBackground";

/**
 * Full-viewport home texture. `position: fixed` keeps the art anchored to the
 * browser window (including margins outside the 2000px content cap) and avoids
 * scroll-lock jitter from `background-attachment: fixed` on page chrome.
 */
export function HomeLinesBackdrop() {
  const isHome = useHomeRoute();
  const theme = useTheme();
  const { themeMode } = useThemeMode();

  if (!isHome) {
    return null;
  }

  const canvasColor = homeLinesVeilColor(theme);

  return (
    <Box
      aria-hidden
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 0,
        pointerEvents: "none",
        backgroundColor: canvasColor,
        ...homeLinesBackgroundSx(themeMode, canvasColor),
      }}
    />
  );
}
